import React from 'react';

import { cn } from '@lyearn/style';

import Typography from '../../Typography';
import { MenuLabelProps } from './types';

const MenuLabel: React.FC<React.PropsWithChildren<MenuLabelProps>> = (props) => {
  const { className, color = 'text-text-placeholder', label, variant = 'label-caps' } = props;

  return (
    <Typography as="p" className={cn('pb-4 px-10 pt-8', className)} color={color} variant={variant}>
      {label}
    </Typography>
  );
};

export { MenuLabelProps };
export default React.memo(MenuLabel);
